(() => {
  const HEADING_TAGS = new Set(['H1', 'H2', 'H3', 'H4', 'H5', 'H6']);

  function makeCard(modifier) {
    const card = document.createElement('article');
    card.className = 'fnf-story__detail-card';
    if (modifier) card.classList.add(`fnf-story__detail-card--${modifier}`);
    return card;
  }

  function hasRenderableContent(node) {
    const text = (node.textContent || '').trim();
    return Boolean(text || node.querySelector('img, video, iframe, table'));
  }

  function enhanceStory(section) {
    const root = section.querySelector('[data-fnf-story-description]');
    if (!root || root.dataset.fnfEnhanced === 'true') return;

    const sourceNodes = Array.from(root.children);
    if (!sourceNodes.length) return;

    const fragment = document.createDocumentFragment();
    let currentCard = null;
    let sawHeading = false;

    sourceNodes.forEach((node) => {
      const tag = node.tagName;

      if (tag === 'HR') {
        currentCard = null;
        return;
      }

      if (!hasRenderableContent(node)) return;

      if (HEADING_TAGS.has(tag)) {
        sawHeading = true;
        currentCard = makeCard('');
        node.classList.add('fnf-story__detail-title');
        currentCard.appendChild(node);
        fragment.appendChild(currentCard);
        return;
      }

      if (!currentCard) {
        currentCard = makeCard(sawHeading ? '' : 'lead');
        fragment.appendChild(currentCard);
      }

      if (tag === 'UL' || tag === 'OL') node.classList.add('fnf-story__detail-list');
      if (tag === 'P' && /^(✓|✔|☑|•|👉|⭐|🌿|🥜)/.test((node.textContent || '').trim())) {
        node.classList.add('fnf-story__bullet-row');
      }

      currentCard.appendChild(node);
    });

    if (!fragment.childNodes.length) return;

    root.replaceChildren(fragment);

    const cards = Array.from(root.children).filter((element) =>
      element.classList.contains('fnf-story__detail-card')
    );

    cards.forEach((card, index) => {
      const textLength = (card.textContent || '').trim().length;
      const listItems = card.querySelectorAll('li').length;

      if (index === 0) {
        card.classList.add('fnf-story__detail-card--lead');
        card.classList.add('fnf-story__detail-card--wide');
      }

      if (textLength > 420 || listItems > 4 || card.querySelector('table')) {
        card.classList.add('fnf-story__detail-card--wide');
      }
    });

    if (cards.length === 1) root.classList.add('fnf-story__description--single');
    root.dataset.fnfEnhanced = 'true';
  }

  function init(scope) {
    const context = scope || document;
    const stories = [];

    if (context.matches && context.matches('[data-fnf-story]')) stories.push(context);
    if (context.querySelectorAll) {
      context.querySelectorAll('[data-fnf-story]').forEach((section) => stories.push(section));
    }

    stories.forEach(enhanceStory);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
